import { ICompany } from "@/features/control/auditors/type"
import { IResponse } from "@/shared/types"
import { requestAuth } from "@/shared/utils/axios"
import { SubmitCompanyFormType, SubmitOrganizationFormType } from "../validation-schema"

interface ICompaniesParams {
  search: string
}

export const getCompaniesShortList = async (params: ICompaniesParams): Promise<IResponse<ICompany>> => {
  const res = await requestAuth("/companies/short-list/", { params })
  return res.data
}
export const getOrganizationsShortList = async (): Promise<IResponse<ICompany>> => {
  const res = await requestAuth("/organizations/short-list/")
  return res.data
}

export const submitCompany = async (data: SubmitCompanyFormType) => {
  const res = await requestAuth.post("/sso/select-company/", data)
  return res.data
}

export const submitOrganization = async (data: SubmitOrganizationFormType) => {
  const res = await requestAuth.post("/sso/select-organization/", data)
  return res.data
}
export const submitRole = async ({ session_id, base_role }: { session_id: string; base_role: string }) => {
  const res = await requestAuth.post("/sso/select-role/", { session_id, base_role })
  return res.data
}

export const completeRegistration = async (data: { session_id: string }) => {
  const res = await requestAuth.post("/sso/complete-registration/", data)
  return res.data
}
